import i18n from "../i18n";

export const getAppLanguageCode = (language = i18n.language) => {
  const lng = String(language || "es").toLowerCase();
  if (lng.startsWith("ja")) return "ja";
  if (lng.startsWith("en")) return "en";
  return "es";
};

export const getMomentLocale = (language = i18n.language) => {
  const code = getAppLanguageCode(language);
  if (code === "ja") return "ja";
  if (code === "en") return "en";
  return "es";
};

export const getIntlLocale = (language = i18n.language) => {
  const code = getAppLanguageCode(language);
  if (code === "ja") return "ja-JP";
  if (code === "en") return "en-US";
  return "es-CL";
};

export const getMomentGbLocale = (language = i18n.language) => {
  const code = getAppLanguageCode(language);
  if (code === "ja") return "ja";
  if (code === "en") return "en-gb";
  return "es";
};

export const isEnglishLanguage = (language) =>
  getAppLanguageCode(language) === "en";

export const usesCommaDecimalSeparator = (language) =>
  getAppLanguageCode(language) === "es";
